var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlayList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "B6086DCF-EF4D-45F9-BA38-AD87B6C6545E")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-",
    transform: "translate(-21.000000, -830.000000)",
    fill: "#4B4B4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-/-Meus-Canais--Copy-8",
    transform: "translate(0.000000, 819.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3535534,21.6223523 C36.5267874,21.6223523 36.6970501,21.6673549 36.8476599,21.752951 L40.7735525,23.984152 C41.2537096,24.2570396 41.4217348,24.8675028 41.1488473,25.3476599 C41.0598364,25.5042784 40.9301709,25.6339438 40.7735525,25.7229547 L36.8476599,27.9541558 C36.3675028,28.2270433 35.7570396,28.0590181 35.484152,27.578861 C35.398556,27.4282512 35.3535534,27.2579884 35.3535534,27.0847545 L35.3535534,22.6223523 C35.3535534,22.0700676 35.8012686,21.6223523 36.3535534,21.6223523 Z M32,23 C32.5522847,23 33,23.4477153 33,24 L33,25 C33,25.5522847 32.5522847,26 32,26 L22,26 C21.4477153,26 21,25.5522847 21,25 L21,24 C21,23.4477153 21.4477153,23 22,23 L32,23 Z M40,17 C40.5522847,17 41,17.4477153 41,18 L41,19 C41,19.5522847 40.5522847,20 40,20 L22,20 C21.4477153,20 21,19.5522847 21,19 L21,18 C21,17.4477153 21.4477153,17 22,17 L40,17 Z M40,11 C40.5522847,11 41,11.4477153 41,12 L41,13 C41,13.5522847 40.5522847,14 40,14 L22,14 C21.4477153,14 21,13.5522847 21,13 L21,12 C21,11.4477153 21.4477153,11 22,11 L40,11 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlayList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play-list.32533a8f.svg";
export { ForwardRef as ReactComponent };